import type { FC } from 'react';

import { ControlledTextField } from '@components/Form';
import type { ControlledTextFieldProps } from '@components/Form';

import type { HardwareVersionFormValues } from './HardwareVersionFormDialog';

export type HardwareVersionControlledTextFieldProps =
  ControlledTextFieldProps<HardwareVersionFormValues>;

export const HardwareVersionControlledTextField: FC<HardwareVersionControlledTextFieldProps> = ({
  controllerProps,
  textFieldProps,
}) => {
  return (
    <ControlledTextField
      controllerProps={{
        rules: { required: 'This field is required' },
        ...controllerProps,
      }}
      textFieldProps={{ helperText: ' ', required: true, ...textFieldProps }}
    />
  );
};
